import React, { useCallback } from 'react'
import styled from 'styled-components'
import TimeScale from './TimeScale'
import { RangeSlider } from 'react-double-range-slider'
import 'react-double-range-slider/dist/cjs/index.css'
import './TimeScaleSlider.css'

interface TimeScaleSliderProps {
  startHour: number
  endHour: number
  updateTimeSelection: (startTime: number, endTime: number) => void
}

const SliderContainer = styled.div`
  width: 40%;
  height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const TimeScaleSlider: React.FC<TimeScaleSliderProps> = ({
  startHour,
  endHour,
  updateTimeSelection,
}) => {
  const handleSliderChange = useCallback(
    (e: any) => {
      let newMin: number = Number(e.min)
      let newMax: number = Number(e.max)
      if (newMax === newMin) {
        if (newMax === 24) {
          newMin--
        } else {
          newMax++
        }
      }
      updateTimeSelection(24 - newMin, 24 - newMax)
    },
    [updateTimeSelection]
  )

  return (
    <SliderContainer>
      <TimeScale />
      <RangeSlider
        value={{ min: 0, max: 24 }}
        from={24 - startHour}
        to={24 - endHour}
        onChange={handleSliderChange}
        tooltipPosition='over'
        tooltipVisibility='never'
        hasSteps
      />
    </SliderContainer>
  )
}

export default TimeScaleSlider
